// shared/HelpIcon.jsx
// Reusable help icon component with tooltip functionality
// Extracted from CompetitiveAnalysisView.jsx for better reusability

import React from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * Help icon with tooltip - provides contextual help information
 * @param {Object} props - Component props
 * @param {string} props.title - Tooltip title
 * @param {string} props.description - Tooltip description text
 * @returns {JSX.Element} Help icon with tooltip
 */
const HelpIcon = ({ title, description }) => (
    <div className="inline-block relative group ml-1">
        <HelpCircle className="w-4 h-4 text-gray-400 inline-block cursor-help" />
        <div className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 absolute z-10 
            bg-gray-900 text-white text-sm rounded p-2 shadow-lg w-64 bottom-full mb-2 left-1/2 transform -translate-x-1/2">
            <div className="font-medium mb-1">{title}</div>
            <div className="text-xs text-gray-300">{description}</div>
            <div className="absolute w-0 h-0 border-solid border-t-8 border-t-gray-900 border-x-8 border-x-transparent border-b-0 
                top-full left-1/2 transform -translate-x-1/2"></div>
        </div>
    </div>
);

export default HelpIcon;
